import { render } from "./AdminAccountCreatePage.vue?vue&type=template&id=8c386d66&lang=true"
import script from "./AdminAccountCreatePage.vue?vue&type=script&lang=js"
export * from "./AdminAccountCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__